/**
 * Classic “92 trace minerals” list commonly cited in sea moss education/marketing.
 * Spellings corrected from the brand reference sheet (Florine→Fluorine, Phosphorous→Phosphorus).
 * This is an educational catalogue — not a lab certificate for every Moss Matrix jar.
 */
export const TRACE_MINERALS_COUNT = 92;

export const TRACE_MINERALS_SPELLING_NOTE =
  "Names use standard English spellings (e.g. Fluorine, Phosphorus). Some printed lists use older or informal variants.";

export const TRACE_MINERALS = [
  "Actinium",
  "Aluminum",
  "Americium",
  "Antimony",
  "Argon",
  "Arsenic",
  "Astatine",
  "Barium",
  "Berkelium",
  "Beryllium",
  "Bismuth",
  "Bohrium",
  "Boron",
  "Bromine",
  "Cadmium",
  "Caesium",
  "Calcium",
  "Californium",
  "Carbon",
  "Cerium",
  "Chlorine",
  "Chromium",
  "Cobalt",
  "Copper",
  "Curium",
  "Dubnium",
  "Dysprosium",
  "Einsteinium",
  "Erbium",
  "Europium",
  "Fermium",
  "Fluorine",
  "Francium",
  "Gadolinium",
  "Gallium",
  "Germanium",
  "Gold",
  "Hafnium",
  "Hassium",
  "Helium",
  "Holmium",
  "Hydrogen",
  "Indium",
  "Iodine",
  "Iridium",
  "Iron",
  "Krypton",
  "Lanthanum",
  "Lead",
  "Lithium",
  "Lutetium",
  "Magnesium",
  "Manganese",
  "Mercury",
  "Molybdenum",
  "Neodymium",
  "Neon",
  "Neptunium",
  "Nickel",
  "Niobium",
  "Nitrogen",
  "Osmium",
  "Palladium",
  "Phosphorus",
  "Platinum",
  "Plutonium",
  "Polonium",
  "Potassium",
  "Praseodymium",
  "Promethium",
  "Protactinium",
  "Radium",
  "Radon",
  "Rhenium",
  "Rhodium",
  "Rubidium",
  "Ruthenium",
  "Samarium",
  "Scandium",
  "Selenium",
  "Silicon",
  "Silver",
  "Sodium",
  "Strontium",
  "Sulphur",
  "Tantalum",
  "Technetium",
  "Tellurium",
  "Terbium",
  "Thallium",
  "Thorium",
  "Zinc",
];

if (TRACE_MINERALS.length !== TRACE_MINERALS_COUNT) {
  // Dev guard — keep list length honest if the array is edited.
  // eslint-disable-next-line no-console
  console.warn(
    `[traceMinerals] Expected ${TRACE_MINERALS_COUNT} entries, found ${TRACE_MINERALS.length}`
  );
}
